import { tv } from '~/utils/tv'

const productHeaderStyles = tv({
  slots: {
    root: [
      'min-w-80 max-w-3xl space-y-[var(--spacing-stack-threepulse)] bg-[var(--color-fill-neutral-default)] p-[var(--padding-inset-fourpulse)]',
    ],
    heading: [
      'line-clamp-2 font-bold font-sans text-[length:var(--font-size-fivepulse)] text-[var(--color-text-neutral-default)] leading-[var(--line-height-small)]',
    ],
    info: 'flex min-w-[184px] gap-x-[var(--spacing-inline-twopulse)]',
  },
})

export const {
  root: rootStyles,
  heading: headingStyles,
  info: infoStyles,
} = productHeaderStyles()
